import React from 'react';
import { Link } from 'react-router-dom';
import { Alert, Container } from 'reactstrap';

// A signed-out visitor is asked to sign in rather than shown an error.
const signedOut = message => /sign in/i.test(message || '');

export default function Layout({ title, crumbs = [], error, children }) {
  return <main className="page-content strategies"><Container fluid>
    <div className="page-title-box d-sm-flex align-items-center justify-content-between"><h4 className="mb-sm-0">{title}</h4><div className="page-title-right"><ol className="breadcrumb m-0"><li className="breadcrumb-item"><Link to="/strategies">My Strategies</Link></li>{crumbs.map(c => <li key={c.to} className="breadcrumb-item"><Link to={c.to}>{c.label}</Link></li>)}<li className="breadcrumb-item active">{title}</li></ol></div></div>
    <p className="text-muted fs-11 mb-3">ForecastNest provides AI-generated market analysis and quantitative research for informational and educational purposes only. Nothing here constitutes financial, investment, legal, or tax advice. Conduct your own research and consult a licensed financial advisor before making investment decisions.</p>
    {error && (signedOut(error)
      ? <Alert color="info">Your strategies are private to your account. <Link to="/login">Sign in</Link> to see them, or <Link to="/register">create a free account</Link>.</Alert>
      : <Alert color="danger">{error}</Alert>)}
    {children}
  </Container></main>;
}

export const pct = v => (v === null || v === undefined ? '—' : `${v > 0 ? '+' : ''}${(v * 100).toFixed(2)}%`);
export const tone = v => (v > 0 ? 'text-success' : v < 0 ? 'text-danger' : '');
export const horizonLabel = h => `${parseInt(h, 10)} trading ${h === '1d' ? 'day' : 'days'}`;
// "Claude Sonnet 5.5 · Effort: medium": the model and how it was run, when stated.
export const modelLabel = p => (p.model_config ? `${p.model_name} · ${p.model_config}` : p.model_name);
